<template>
	<ul :class="['checkbox-list', 'checkbox-list--type-' + type ]">
		<li v-for="(item, i) in items" :key="'item-' + i">
			<Icon :icon="icon"/>
			<span v-html="item.text"/>
		</li>
	</ul>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";

export default {
	components: {Icon},

	props: {
		items: {
			type: Array,
			required: true
		},
		type: {
			type: String,
			required: true
		}
	},

	computed: {
		isTypePositive ()
		{
			return this.type === 'positive';
		},
		icon ()
		{
			return this.isTypePositive
				? 'check-square-filled'
				: 'cross-square-filled';
		}
	}
}
</script>
